import React from 'react';
import PropTypes from 'prop-types';

import {type IconComponent} from './icon-component';

export const Border: IconComponent<any> = ({color}) => (
    <rect fill="transparent" stroke={color} strokeWidth={37.5} x={0} y={0} height={500} width={500} rx={62} ry={62} />
);
Border.propTypes = {
    color: PropTypes.string,
};
